import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ILoading } from '../models/loading.models';
import { DesignService } from 'src/app/shared/services/config/design.service';

@Injectable({
	providedIn: 'root',
})
export class LoadingService {
	// #region Services
	private designService = inject(DesignService);
	// #endregion

	private showLoading: BehaviorSubject<ILoading>;
	private showLoadingIframe: BehaviorSubject<ILoading>;
	private readonly resumeClickSubject = new Subject<void>();

	/** Clic en el link «Pulsa aquí para retomar» del overlay global. */
	public readonly resumeClick$: Observable<void> = this.resumeClickSubject.asObservable();

	constructor() {
		this.showLoading = new BehaviorSubject<ILoading>({
			show: false,
			text: '',
			watermark: false,
			opaque: false,
			showResumePrompt: false,
			hideTextKeepSpace: false,
		});
		// Iframe loading
		this.showLoadingIframe = new BehaviorSubject<ILoading>({
			show: false,
			text: '',
			watermark: false,
			opaque: false,
			img: 'assets/images/spinner.svg',
		});
	}

	public loading(): Observable<ILoading> {
		return this.showLoading.asObservable();
	}

	public setLoading(value: ILoading): void {
		this.showLoading.next(value);
	}

	/** Parchea flags del loader sin resetear texto/spinner. */
	public patchLoading(partial: Partial<ILoading>): void {
		this.showLoading.next({ ...this.showLoading.getValue(), ...partial });
	}

	public notifyResumeClick(): void {
		this.resumeClickSubject.next();
	}

	public show(text = '', watermark = true) {
		const customSpinner = this.designService.getCustomSpinnerUrl();
		this.showLoading.next({
			show: true,
			text: text,
			watermark: watermark,
			opaque: true,
			showResumePrompt: false,
			hideTextKeepSpace: false,
			...(customSpinner ? { img: customSpinner } : {}),
		});
	}

	public hide() {
		this.showLoading.next({
			show: false,
			text: '',
			watermark: false,
			opaque: false,
			showResumePrompt: false,
			hideTextKeepSpace: false,
		});
	}

	// Iframe
	public iframeLoading(): Observable<ILoading> {
		return this.showLoadingIframe.asObservable();
	}

	public setIframeLoading(value: ILoading): void {
		this.showLoadingIframe.next(value);
	}

	public showIframe(text = '') {
		const customSpinner = this.designService.getCustomSpinnerUrl();
		const defaultImg = this.designService.isDarkMode() ? 'assets/images/spinner-white.svg' : 'assets/images/spinner.svg';
		this.showLoadingIframe.next({
			show: true,
			text: text,
			watermark: false,
			opaque: true,
			img: customSpinner ?? defaultImg,
		});
	}

	public hideIframe() {
		this.showLoadingIframe.next({ show: false, text: '', watermark: false, opaque: false });
	}
}
